<template>
	<div class="calls-box">
		<div class="filters-box justify-content-between">
			<div class="filter" style="width:100%">
				<div class="filter-input">
					<i class="icon icon-search"></i>
					<input type="text" class="form-control" placeholder="Buscar" v-model="search" />
					<div class="btn btn-light btn-clear-filter" v-if="search" @click="search = null">
						<i class="icon icon-close"></i>
					</div>
				</div>
			</div>
		</div>

		<div class="calls">
			<div
				class="call"
				v-ripple
				v-for="item in filteredCalls"
				:key="item.id"
				:class="{
					awaiting: item.status == 'AWAITING',
					in_progress: item.status == 'IN_PROGRESS',
					ended: item.status == 'ENDED'
				}"
				@click="takeCall(item)"
			>
				<div class="circle">
					<div class="circle-icon">
						<i class="icon icon-phone"></i>
					</div>
				</div>
				<div class="data">
					<div class="client">
						<div class="name">{{ item.client.name }} {{ item.client.lastname }}</div>
						<div class="info">{{ item.client.email }}</div>
					</div>
					<div class="connecting" v-if="item.connecting">
						Conectando
						<div class="dot-pulse"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="alert alert-info text-center" v-if="calls.length == 0">No se han encontrado llamadas</div>

		<Pagination :pageData="pagination" @pageChange="pageChange" />
	</div>
</template>

<script>
import gql from "graphql-tag"
import mixins from "@/mixins/mixins"
import listMixins from "@/mixins/listMixins"

export default {
	name: "CallsHistory",
	mixins: [mixins, listMixins],

	data() {
		return {
			loading: false,
			intervalid: null,
			search: null,
			hasCallInProgress: false,
			incommingCalls: 0
		}
	},

	async beforeMount() {
		this.load()
		this.intervalid = setInterval(() => {
			this.load()
		}, 3000)

		this.$notification.requestPermission().then(console.log)
	},

	beforeDestroy() {
		clearInterval(this.intervalid)
	},

	computed: {
		calls: function() {
			return this.$store.getters.calls
		},
		//filtrar calls by search in name and email
		filteredCalls: function() {
			if (this.search) {
				return this.calls.filter((item) => {
					return (
						item.client.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
						item.client.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1
					)
				})
			}
			return this.calls
		},
		currentCall: function() {
			return this.$store.getters.currentCall
		}
	},

	watch: {
		// watch calls for new incomming call
		calls: function(newVal, oldVal) {
			let hasIncommingCall = false
			const incommingCalls = newVal.filter((item) => item.status == "AWAITING").length
			if (this.incommingCalls < incommingCalls) {
				hasIncommingCall = true
			}
			this.incommingCalls = incommingCalls
			if (hasIncommingCall) {
				this.showNotification()

				this.playNotificationSound()
			}
		}
	},

	methods: {
		load() {
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int) {
							calls(take: $take, skip: $skip) {
								data {
									id
									client {
										id
										name
										email
										phone
									}
									vonageSessionId
									vonagePublicKey
									vonageToken
									status
									createdAt
									startedAt
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					const calls = data.calls.data.map((item) => {
						return { ...item, connecting: false }
					})
					// busco alguna call con estado IN_PROGRESS
					const callInProgress = calls.find((item) => {
						return item.status == "IN_PROGRESS"
					})
					this.$store.commit("setCurrentCall", callInProgress || {})
					this.$store.commit("setCalls", calls)
					this.loading = false
				})
		},

		takeCall(call) {
			if (call.status == "AWAITING") {
				console.log(this.currentCall)
				// si tengo llamada en curso le aviso que debe finalizarla primero
				if (this.currentCall && this.currentCall.status == "IN_PROGRESS") {
					alert("Debe finalizar la llamada en curso para tomar otra.")
					return
				}

				let index = this.calls.findIndex((item) => {
					return item.id == call.id
				})
				this.calls[index].connecting = true

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($id: ID!) {
								callAttend(id: $id) {
									id

									status
								}
							}
						`,
						variables: {
							id: call.id
						}
					})
					.then(({ data }) => {
						// this.$store.commit('setCurrentCall', data.callAttend)

						this.calls[index] = {
							...this.calls[index],
							...data.callAttend,
							connecting: false
						}
					})
					.catch((error) => {
						this.errors = this.parseGQLErrors(error)
					})
			}
		},

		showNotification() {
			const notification = {
				title: "Tienes una nueva llamada para atender",
				options: {
					// body: 'This is an example!'
				},
				events: {
					onerror: function() {
						console.log("Custom error event was called")
					},
					onclick: function() {
						console.log("Custom click event was called")
					},
					onclose: function() {
						console.log("Custom close event was called")
					},
					onshow: function() {
						console.log("Custom show event was called")
					}
				}
			}
			this.$notification.show(notification.title, notification.options, notification.events)
		},

		playNotificationSound() {
			console.log("playNotificationSound", this.currentCall, this.incommingCalls)
			const audio = new Audio(require("@/assets/notification.mp3"))
			audio.play()

			// si no hay llamada en curso, y hay una llamada en espera, sueno de nuevo
			if (this.incommingCalls > 0 && (!this.currentCall || this.currentCall.status != "IN_PROGRESS")) {
				setTimeout(() => {
					this.playNotificationSound()
				}, 2000)
			}
		},

		deletePrompt(item) {
			this.$dialog.confirm("¿Está seguro que desea eliminar este usuario?").then(() => {
				this.delete(item)
			})
		},

		delete(item) {
			item.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							userDelete(id: $id) {
								id
							}
						}
					`,
					variables: {
						id: item.id
					}
				})
				.then(() => {
					this.$toast.success("Usuario eliminado correctamente")
					this.load()
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					item.loading = false
				})
		}
	}
}
</script>

<style lang="scss">
.calls-box {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: calc(100vh - 170px);
	overflow: hidden;

	.filters-box {
		padding: 16px 18px 12px 18px;
		flex-shrink: 0;
		flex-basis: 0;
	}
}
.calls {
	flex-grow: 1;
	padding: 16px;
	overflow: auto;

	.call {
		display: flex;
		align-items: center;
		width: 100%;
		border-radius: 28px;
		padding: 8px;
		background-color: #eeeeee;
		color: #333;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0);
		transition: all 0.3s ease;
		cursor: pointer;
		margin-bottom: 8px;
		position: relative;
		overflow: hidden;

		&:hover {
			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
		}

		.circle {
			width: 40px;
			height: 40px;
			flex-shrink: 0;
			border-radius: 50%;
			background-color: #333;
			display: flex;
			align-items: center;
			justify-content: center;

			.icon {
				font-size: 20px;
				color: #fff;
			}
		}

		.data {
			margin-left: 8px;
			flex-grow: 1;

			.client {
				.name {
					font-size: 15px;

					line-height: 0.9rem;
				}
				.info {
					font-size: 14px;
					opacity: 0.8;
					line-height: 0.9rem;
				}
			}
		}

		&.awaiting .circle {
			background: rgba(51, 217, 178, 1);
			box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
			animation: pulse-green 2s infinite;

			.circle-icon {
				animation: shake-animation 0.82s cubic-bezier(0.36, 0.07, 0.19, 1) infinite;
				transform: translate3d(0, 0, 0);
			}
			.icon-phone {
				transform: rotate(94deg);
			}
		}

		&.in_progress {
			background: rgba(51, 217, 178, 1);
			color: #fff;

			&:before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				border-radius: 28px;
				box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
				animation: pulse-green 2s infinite;
			}
			.circle {
				background-color: #fff;
			}

			.icon-phone {
				color: rgba(51, 217, 178, 1);
				transform: rotate(94deg);
			}
		}

		&.ended .circle {
			background: #d3d3d3;
			animation: endedRed 2s 1;

			.icon-phone {
				transform: rotate(227deg);
			}
		}

		.connecting {
			display: flex;
			align-items: center;

			.dot-pulse {
				margin-left: 24px;
			}
		}
	}
}
@keyframes endedRed {
	0% {
		background: rgb(217, 51, 51);
		box-shadow: 0 0 0 0 rgba(217, 51, 51, 1);
		animation: pulse-red 2s infinite;
	}
	100% {
		background: #d3d3d3;
	}
}

@keyframes shake-animation {
	10%,
	90% {
		transform: translate3d(0px, 0, 0);
	}

	20%,
	80% {
		transform: translate3d(0px, 0, 0);
	}

	30%,
	50%,
	70% {
		transform: translate3d(-2px, 0, 0);
	}

	40%,
	60% {
		transform: translate3d(2px, 0, 0);
	}
}

@keyframes pulse-green {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
	}
}

@keyframes pulse-red {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
	}
}

.dot-pulse {
	position: relative;
	left: -9999px;
	width: 6px;
	height: 6px;
	border-radius: 5px;
	background-color: #2a77befb;
	color: #2a77befb;
	box-shadow: 9999px 0 0 -5px #2a77befb;
	animation: dotPulse 1.5s infinite linear;
	animation-delay: 0.25s;
}

.dot-pulse::before,
.dot-pulse::after {
	content: "";
	display: inline-block;
	position: absolute;
	top: 0;
	width: 6px;
	height: 6px;
	border-radius: 5px;
	background-color: #2a77befb;
	color: #2a77befb;
}

.dot-pulse::before {
	box-shadow: 9984px 0 0 -4px #2a77befb;
	animation: dotPulseBefore 1.5s infinite linear;
	animation-delay: 0s;
}

.dot-pulse::after {
	box-shadow: 10014px 0 0 -4px #2a77befb;
	animation: dotPulseAfter 1.5s infinite linear;
	animation-delay: 0.5s;
}

@keyframes dotPulseBefore {
	0% {
		box-shadow: 9984px 0 0 -4px #2a77befb;
	}
	30% {
		box-shadow: 9984px 0 0 2px #2a77befb;
	}
	60%,
	100% {
		box-shadow: 9984px 0 0 -4px #2a77befb;
	}
}

@keyframes dotPulse {
	0% {
		box-shadow: 9999px 0 0 -4px #2a77befb;
	}
	30% {
		box-shadow: 9999px 0 0 2px #2a77befb;
	}
	60%,
	100% {
		box-shadow: 9999px 0 0 -4px #2a77befb;
	}
}

@keyframes dotPulseAfter {
	0% {
		box-shadow: 10014px 0 0 -4px #2a77befb;
	}
	30% {
		box-shadow: 10014px 0 0 2px #2a77befb;
	}
	60%,
	100% {
		box-shadow: 10014px 0 0 -4px #2a77befb;
	}
}
</style>
